import React from 'react'
import Title from './title'
import { SideBySideLayout, Heading } from '../MDS-web-ui/src'
import { ActiveLink } from './Link'
import { useTranslation } from 'react-i18next'

const Missing = () => {
  const { t } = useTranslation()

  return (
    <Title page="404">
      <SideBySideLayout LinkComponent={ActiveLink}>
        <Heading mt={4}>{t('main.nothingHere')}</Heading>
      </SideBySideLayout>
    </Title>
  )
}
export default Missing
